const section = document.querySelector('.product-ingredients')

function init() {
  if (!section) return
  productIngredientViewMore()
}

function productIngredientViewMore() {
  const viewMoreBtn = section.querySelector(
    '.i-content-controls button.i-content-controls__button'
  )

  const hiddenBlocks = section.querySelectorAll(
    '.body-a-container .body-a_block[data-didnt-make-the-cut]'
  )

  // Count all blocks, not just hidden ones
  const allBlocks = section.querySelectorAll(
    '.body-a-container li.body-a_block'
  )

  if (!viewMoreBtn || !hiddenBlocks) return

  // Hide the button if there are 4 or fewer blocks
  if (allBlocks.length <= 4) {
    viewMoreBtn.style.display = 'none'
    return
  }

  viewMoreBtn.addEventListener('click', function () {
    const isExpanded = $(this).attr('data-status') === '1'

    if (!isExpanded) {
      expandIngredients(hiddenBlocks, this)
      return
    }
    collapseIngredients(hiddenBlocks, this)
  })
}

function expandIngredients(hiddenBlocks, button) {
  $(hiddenBlocks).each(function () {
    const $block = $(this)
    $block.css({
      display: 'grid',
      overflow: 'hidden',
      height: '0',
    })

    const targetHeight = $block.prop('scrollHeight')

    $block.animate({ height: targetHeight }, 400, function () {
      $(this).css('height', 'auto')
    })
  })

  const viewLessText = $(button).attr('data-view-less-text')
  $(button).find('span').text(viewLessText)
  $(button).attr('data-status', '1')
}

function collapseIngredients(hiddenBlocks, button) {
  $(hiddenBlocks).each(function () {
    const $block = $(this)

    // Set a fixed height (current height)
    const currentHeight = $block.height()
    $block.css({
      height: `${currentHeight}px`,
      overflow: 'hidden',
    })

    // Animate to height 0
    $block.animate({ height: 0 }, 400)
  })

  const viewMoreText = $(button).attr('data-view-more-text')
  $(button).find('span').text(viewMoreText)
  $(button).attr('data-status', '0')
}

export default init
